export enum TypePages {
  send = 'send',
  bridge = 'bridge',
  swap = 'swap',
}

export type TypeTxsT = 'swap' | 'deposit' | 'withdraw';

export enum TxsType {
  Swap = 'swap',
  Deposit = 'deposit',
  Withdraw = 'withdraw',
}
